import { gql } from '@apollo/client'
import { useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useFormsState = () => React.useContext(Context) || {}
export const useForms = () => useFormsState()?.forms || []

const QUERY = gql`
  query Forms($page: Int, $search: String, $sort: FormSort) {
    forms(page: $page, search: $search, sort: $sort) {
      id
      name
      repliesCount
      access
      shareCode
      checklist {
        id
        name
      }
    }
  }
`

const FormsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: { page: 1, search, sort: { field: field || 'NAME', type } },
    client: formsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default FormsLoader
